import React from 'react';

import { searchAdGroupEditStepConfigs } from '../steps/step-configs';
import { SEARCH_AD_GROUP_EDIT_WIZARD_STEP_PATHS } from '../steps/step-utils';
import { EditWizard } from './edit-wizard';

export const SearchAdGroupEditWizard = props => (
  <EditWizard
    stepConfigs={searchAdGroupEditStepConfigs}
    scenarioName="SearchAdGroupEditRevamp"
    activityName="SearchAdGroupEditWizard"
    wizardLoggerFlowName="SearchCampaign"
    wizardLoggerSubFlowName="SearchAdGroupEdit"
    wizardLoggerStepToPage={SEARCH_AD_GROUP_EDIT_WIZARD_STEP_PATHS}
    perfMarkerName="SearchAdGroupEditWizard"
    onDoneNavigateToSiteMapId="ads"
    {...props}
  />
);
